<template>
  <div>
    <center>
      <h5 class="m-3">Вы можете приобрести лицензию позвонив в отдел продаж</h5>
      <span style="font-size: 18px">Телефон отдела продаж:&nbsp;</span>
      <a
        style="display: inline"
        href="tel:
		88007758351
	"
      >
        <h5 style="display: inline">8 800 775-83-51</h5> </a
      ><br />
      Рабочее время: <b>с 9:00 до 18:00</b> <br />

      Время Московское

      <h3 class="m-3">или</h3>
      <b-btn variant="success" href="https://mst.su/firerisks/buy/" target="_blank" class="m-2"
        >Приобрести онлайн</b-btn
      >
    </center>
  </div>
</template>
<script>
import "vue-form-generator/dist/vfg.css";
export default {
  name: "keys",
  created() {
    this.fetchData();
  },
  mounted() {
    this.model.name =
      this.$auth.user().profile.last_name +
      " " +
      this.$auth.user().profile.name +
      " " +
      this.$auth.user().profile.second_name;
    this.$http.get("user/security").then((response) => {
      this.model.phone = response.data.phone;
      this.model.email = response.data.email;
      // JSON responses are automatically parsed.
      // this.errors = response.data.errors
      //           console.log(this.errors)
    });
  },
  data() {
    return {
      payments: [],
      bill: null,
      creatingBill: false,
      fields: [
        // A column that needs custom formatting
        { key: "created_at", label: "Создан" },
        // A virtual column made up from two fields
        { key: "packageId", label: "Пакет" },
        { key: "status", label: "Статус" },
        // A virtual column made up from two fields
        { key: "file", label: "Счёт" },
        // A virtual column made up from two fields
      ],
      packeges: [],
      userType: 1,
      package_id: null,
      agreement: false,
      options: [
        { text: "Физическое лицо", value: 1 },
        { text: "Организация", value: 2 },
      ],
      model: {
        name: "",
        email: null,
        phone: null,
        validator: {},
      },
      schema: {
        groups: [
          {
            fields: [
              {
                type: "input",
                inputType: "text",
                label: "ФИО",
                model: "name",
                placeholder: "Иванов Иван Иванович",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "email",
                label: "Адрес электронной почты",
                model: "email",
                placeholder: "Ваш e-mail адрес",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "tel",
                label: "Контактный телефон",
                model: "phone",
                placeholder: "+7(999)999-9999",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
            ],
          },
        ],
      },
      legalModel: {
        org_name: null,
        name: "",
        address: "",
        email: null,
        phone: null,
        inn: null,
        kpp: null,
        ogrn: null,
        validator: {},
      },
      legalSchema: {
        groups: [
          {
            fields: [
              {
                type: "input",
                inputType: "text",
                label: "Полное наименование организации",
                model: "org_name",
                placeholder: "",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "text",
                label: "Почтовый адрес",
                model: "address",
                placeholder: "",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "ИНН",
                model: "inn",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "КПП",
                model: "kpp",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "ОГРН",
                model: "ogrn",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "text",
                label: "ФИО генерального директора",
                model: "name",
                placeholder: "",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "email",
                label: "Адрес электронной почты",
                model: "email",
                placeholder: "Ваш e-mail адрес",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "tel",
                label: "Контактный телефон",
                model: "phone",
                placeholder: "+7(999)999-9999",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
            ],
          },
        ],
      },
    };
  },
  methods: {
    fetchData() {
      this.$http
        .post("payment/get-list", this.form)
        .then((response) => {
          this.packeges = response.data.packages;
          this.payments = response.data.payments;
        })
        .catch((e) => {
          console.error(e);
        });
    },
    legalSend() {
      this.$http
        .post("payment/payment-legal?package_id=" + this.package_id + "&ip=1", this.legalModel)
        .then((response) => {
          this.bill = response.data;
          this.$refs.bill.show();
        })
        .catch((e) => {
          if (e.response.data) {
            this.legalModel.validator = e.response.data;
            this.$refs.legal.validate();
          }
        });
    },
    test() {},
    send() {
      this.$http
        .post("payment/payment?package_id=" + this.package_id, this.model)
        .then((response) => {
          window.location.href = response.data;
        })
        .catch((e) => {
          if (e.response.data) {
            this.model.validator = e.response.data;
            this.$refs.fiz.validate();
          }
        });
    },
  },
};
</script>
